import { useState } from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import EToolTip from 'components/others/EToolTip';
import SolarTuningLineDuotone from 'components/icons/SolarTuningLineDuotone';
import SolarIcon from 'components/icons/SolarIcon';
import OffProcessCategories from './OffProcessCategories';

const ProcessCategoryMenu = () => {
    const { t } = useTranslation(['Tasks']);
    const [showDirs, setShowDirs] = useState(false);

    const menu = (
        <Dropdown.Menu className="p-2 shadow-sm warehouse-team-menu" popperConfig={{ strategy: 'fixed' }} renderOnMount>
            <Dropdown.Item
                as="button"
                onClick={(e) => {
                    setShowDirs(true);
                    e.currentTarget.blur();
                }}
            >
                <div className="d-flex align-items-start w-100 text-start">
                    <span className="d-inline-flex align-items-center justify-content-center flex-shrink-0 me-2 item-icon">
                        <SolarIcon name="folder2-open" />
                    </span>
                    <div className="flex-grow-1 min-w-0">
                        <div className="fw-medium">{t('processDirs.categoriesTitle')}</div>
                        <small className="text-muted warehouse-team-menu-hint">{t('processDirs.categoriesHint')}</small>
                    </div>
                </div>
            </Dropdown.Item>
        </Dropdown.Menu>
    );

    return (
        <>
            <EToolTip title={t('processDirs.menuHint')}>
                <span className="d-inline-block">
                    <Dropdown as="span" align="end" className="d-inline-flex">
                        <Dropdown.Toggle
                            as={Button}
                            size="sm"
                            variant="secondary"
                            className="toolbar-menu-btn fs-14 d-inline-flex align-items-center"
                        >
                            <SolarTuningLineDuotone />
                        </Dropdown.Toggle>
                        {typeof document !== 'undefined' ? createPortal(menu, document.body) : menu}
                    </Dropdown>
                </span>
            </EToolTip>

            <OffProcessCategories show={showDirs} onHide={() => setShowDirs(false)} />
        </>
    );
};

export default ProcessCategoryMenu;
